// firebaseConfig.js

import { initializeApp } from 'firebase/app';
import {
  collection,
  getFirestore
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Firebase configuration object from your Firebase console
const firebaseConfig = {
  apiKey: "AIzaSyAptdYYu3UrJgBWka9FJj_Af4CF5iZ3KDY",
  authDomain: "visma-iitbbs-b3f86.firebaseapp.com",
  projectId: "visma-iitbbs-b3f86",
  storageBucket: "visma-iitbbs-b3f86.appspot.com",
  messagingSenderId: "1087225367728",
  appId: "1:1087225367728:web:60a5ed7381cedddb92ff75",
  measurementId: "G-WRCEZ83K7K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore();
const auth = getAuth(app);

const publicationsRef = collection(db, 'publications');
const researchProjectsRef = collection(db, 'researchProjects');

const researchDomainsRef = collection(db, 'researchDomains');

const graduatePhDStudentsRef = collection(db, 'pastScholars/Scholars/graduatePhDStudents');
const pastPostGradStudentsRef = collection(db, 'pastScholars/Scholars/postGraduateStudents');
const pastProjectScholarsRef = collection(db, 'pastScholars/Scholars/projectScholars');


const doctoralScholarsRef = collection(db, 'people/category/doctoralScholars');
const postGraduateStudentsRef = collection(db, 'people/category/postGraduateStudents');
const projectScholarsRef = collection(db, 'people/category/projectScholars');
const underGraduateStudentsRef = collection(db, 'people/category/underGraduateStudents');

const facultyInChargeRef = collection(db, 'people/category/facultyInCharge');

const collaborationsRef = collection(db, 'collaborations');

const labFacilityRef = collection(db, "labFacility");
const photosRef = collection(db, "photos");

const homeRef = collection(db, "home");

export {
  publicationsRef, researchProjectsRef, researchDomainsRef, doctoralScholarsRef,
  postGraduateStudentsRef, projectScholarsRef, facultyInChargeRef, underGraduateStudentsRef, graduatePhDStudentsRef, pastPostGradStudentsRef,
  pastProjectScholarsRef,
  collaborationsRef, labFacilityRef , photosRef, homeRef,
  auth, db
};
